export default "__VITE_ASSET__JEcB7rqz__"